import "./RaikoAlert.scss"
import {Alert, AlertTitle} from "@mui/lab";
import PropTypes, {string} from "prop-types";

export const RaikoAlert = ({type, title, description, className}) => {
    return (
        <Alert severity={type} className={className}>
            <AlertTitle>{title}</AlertTitle>
            <div className={"raikoAlertDescriptionContainer"}>
                {
                    description && description.map((item, index) => {
                        return <span key={index}>{item}</span>
                    })
                }
            </div>
        </Alert>
    )
}

RaikoAlert.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    description: PropTypes.arrayOf(string),
    className: PropTypes.string,
}

export const raikoAlertTypes = {
    warning: "warning",
    error: "error",
    success: "success",
    info: "info"
}